import type { NavigationProp, ParamListBase } from "@react-navigation/native";

type RouteNamesState = {
  routeNames?: string[];
};

export type RouteLookupNavigation = {
  getParent?: <T = RouteLookupNavigation>(id?: string) => T | undefined;
  getState: () => RouteNamesState;
  navigate: (...args: any[]) => void;
};

export const getNavigationForRoute = <ParamList extends ParamListBase>(
  navigation: RouteLookupNavigation,
  routeName: keyof ParamList & string
): NavigationProp<ParamList> => {
  let currentNavigation: RouteLookupNavigation | undefined = navigation;

  while (currentNavigation) {
    const state = currentNavigation.getState() as RouteNamesState;

    if (state.routeNames?.includes(routeName)) {
      return currentNavigation as NavigationProp<ParamList>;
    }

    currentNavigation = currentNavigation.getParent?.();
  }

  return navigation as NavigationProp<ParamList>;
};
